const typesConfig = {
    primary: {
        backgroundColor: 'INK_800',
        textColor: 'SNOW_100',
    },
    destructive: {
        backgroundColor: 'RED_700',
        textColor: 'SNOW_100',
    },
    reverse: {
        backgroundColor: 'SNOW_100',
        textColor: 'INK_800',
    },
};
const getArrowBorderColor = (type, direction, cssPosition) => {
    switch (direction) {
        case 'RIGHT':
            if (cssPosition === 'RIGHT') {
                return typesConfig[type].backgroundColor;
            }
            return 'TRANSPARENT';
        case 'LEFT':
            if (cssPosition === 'LEFT') {
                return typesConfig[type].backgroundColor;
            }
            return 'TRANSPARENT';
        case 'TOP_LEFT':
        case 'TOP_CENTER':
        case 'TOP_RIGHT':
            if (cssPosition === 'TOP') {
                return typesConfig[type].backgroundColor;
            }
            return 'TRANSPARENT';
        case 'BOTTOM_LEFT':
        case 'BOTTOM_CENTER':
        case 'BOTTOM_RIGHT':
            if (cssPosition === 'BOTTOM') {
                return typesConfig[type].backgroundColor;
            }
            return 'TRANSPARENT';
        default:
            return 'TRANSPARENT';
    }
};
const tooltip = {
    types: typesConfig,
    directions: {
        RIGHT: {
            padding: '0.5rem 1rem',
            textAlign: 'left',
            tooltipTop: '50%',
            tooltipBottom: 'auto',
            tooltipLeft: '105%',
            tooltipRight: 'auto',
            tooltipTransform: 'translateY(-50%)',
            arrowTop: '50%',
            arrowBottom: 'auto',
            arrowLeft: 'auto',
            arrowRight: '100%',
            arrowTransform: 'translateY(-50%)',
            arrowBorderColor: getArrowBorderColor,
        },
        LEFT: {
            padding: '0.5rem 1rem',
            textAlign: 'left',
            tooltipTop: '50%',
            tooltipBottom: 'auto',
            tooltipLeft: 'auto',
            tooltipRight: '105%',
            tooltipTransform: 'translateY(-50%)',
            arrowTop: '50%',
            arrowBottom: 'auto',
            arrowLeft: '100%',
            arrowRight: 'auto',
            arrowTransform: 'translateY(-50%)',
            arrowBorderColor: getArrowBorderColor,
        },
        TOP_LEFT: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: 'auto',
            tooltipBottom: '115%',
            tooltipLeft: 'auto',
            tooltipRight: 'auto',
            tooltipTransform: 'none',
            arrowTop: '100%',
            arrowBottom: 'auto',
            arrowLeft: '10%',
            arrowRight: 'auto',
            arrowTransform: 'none',
            arrowBorderColor: getArrowBorderColor,
        },
        TOP_CENTER: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: 'auto',
            tooltipBottom: '115%',
            tooltipLeft: '50%',
            tooltipRight: 'auto',
            tooltipTransform: 'translateX(-50%)',
            arrowTop: '100%',
            arrowBottom: 'auto',
            arrowLeft: '50%',
            arrowRight: 'auto',
            arrowTransform: 'translateX(-50%)',
            arrowBorderColor: getArrowBorderColor,
        },
        TOP_RIGHT: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: 'auto',
            tooltipBottom: '115%',
            tooltipLeft: 'auto',
            tooltipRight: '0',
            tooltipTransform: 'none',
            arrowTop: '100%',
            arrowBottom: 'auto',
            arrowLeft: '70%',
            arrowRight: 'auto',
            arrowTransform: 'none',
            arrowBorderColor: getArrowBorderColor,
        },
        BOTTOM_LEFT: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: '115%',
            tooltipBottom: 'auto',
            tooltipLeft: '0',
            tooltipRight: 'auto',
            tooltipTransform: 'none',
            arrowTop: 'auto',
            arrowBottom: '100%',
            arrowLeft: '20%',
            arrowRight: 'auto',
            arrowTransform: 'none',
            arrowBorderColor: getArrowBorderColor,
        },
        BOTTOM_CENTER: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: '115%',
            tooltipBottom: 'auto',
            tooltipLeft: '50%',
            tooltipRight: 'auto',
            tooltipTransform: 'translateX(-50%)',
            arrowTop: 'auto',
            arrowBottom: '100%',
            arrowLeft: '50%',
            arrowRight: 'auto',
            arrowTransform: 'translateX(-50%)',
            arrowBorderColor: getArrowBorderColor,
        },
        BOTTOM_RIGHT: {
            padding: '0.25rem 1rem',
            textAlign: 'center',
            tooltipTop: '115%',
            tooltipBottom: 'auto',
            tooltipLeft: 'auto',
            tooltipRight: '0',
            tooltipTransform: 'none',
            arrowTop: 'auto',
            arrowBottom: '100%',
            arrowLeft: '70%',
            arrowRight: 'auto',
            arrowTransform: 'none',
            arrowBorderColor: getArrowBorderColor,
        },
    },
};
export default tooltip;
//# sourceMappingURL=tooltip.js.map